<template>
    <div class="admin-company-admin mt-page">

        <b-btn class="float-right" @click="showCreateModal">Add New Admin</b-btn>

        <crud-table :title="$i18n.gt('LABEL_MANAGE_COMPANY_ADMINS')"
                    item-table="company-admin"
                    item-name="Admin"
                    :new-item="newItem"
                    :filters="filters"
                    :display-fields="displayFields"
                    :edit-fields="editFields"
                    ref="adminTable">
        </crud-table>

        <!-- create company admin modal -->
        <b-modal :id="modalId"
                 title="New Company Admin"
                 cancel-variant="danger"
                 ok-title="Create"
                 @ok="createNewAdmin">
            <b-form-group label="User">
                <vue-bootstrap-typeahead :data="participants"
                                         v-model="participantSearch"
                                         placeholder="Type a participant's full email"
                                         :serializer="p => p.email"
                                         @hit="selectedUser = $event">
                </vue-bootstrap-typeahead>
                <small>Type the participant's full email, then click it in the dropdown</small>
            </b-form-group>
            <b-form-group label="Company">
                <b-form-select v-model="selectedCompany"
                               :options="companyOptions">
                </b-form-select>
            </b-form-group>
        </b-modal>

    </div>
</template>

<!-- ----------------------------------------------------------------------- -->

<script>
import Vue from 'vue'
import * as _ from 'lodash'
import VueBootstrapTypeahead from 'vue-bootstrap-typeahead'

/**
 * Page to manage company admins
 */
export default Vue.extend({
    name: 'AdminCompanyAdmin',
    components: { VueBootstrapTypeahead },
    props: {
        resellerId: Number,
    },
    data() {
        return {
            newItem: null, // can't add new items (would need to figure out how to edit userEmail)
            participantSearch: '',
            participants: [],
            selectedCompany: null,
            selectedUser: {},
            displayFields: [
                {key: 'userEmail', sortable: true},
                {
                    key: 'company.name', sortable: true, label: 'Company',
                    get: (item) => {
                        return item.company ? item.company.name : ''
                    }
                },
            ],
            companyOptions: [],
        }
    },
    computed: {
        modalId() {
            return 'createNewAdmin'
        },
        filters() {
            return {
                userEmail: {
                    field: 'userEmail',
                    type: 'string',
                    value: null,
                    label: 'User Email'
                },
                'company.id': {
                    field: 'company.id',
                    type: 'select',
                    value: null,
                    label: 'Company',
                    options: this.companyOptions
                },
                'reseller_id': {
                    field: 'reseller_id',
                    value: this.resellerId ? this.resellerId : null,
                    type: 'hidden'
                },
            }
        },
        editFields() {
            return [
                {key: 'company_id', type: 'select', label: 'Company', options: this.companyOptions},
            ]
        },
    },
    methods: {
        showCreateModal() {
            this.$bvModal.show(this.modalId)
        },
        async getParticipants(email) {
            this.participants = await this.$api.findParticipants(this, email, ['user'])
        },
        async createNewAdmin() {
            const newAdmin = {user_id: this.selectedUser.user.id, company_id: this.selectedCompany}
            await this.$api.createItem(this, 'company-admin', newAdmin)
            this.$refs.adminTable.refresh()
            this.selectedCompany = null
            this.selectedUser = {}
            this.participants = []
            this.participantSearch = ''
        }
    },
    mounted() {
        const filters = {}
        if (this.resellerId) {
            filters.reseller_id = {field: 'reseller_id', value: this.resellerId}
        }
        this.$api.getItems(this, 'company', filters)
            .then((items) => {
                this.companyOptions = _.concat(
                    [{value: null, text: ''}],
                    _.map(items, (company) => {
                        return {value: company.id, text: company.name}
                    })
                )
            })
    },
    watch: {
        participantSearch: _.debounce(function (email) {
            if(email) {
                this.getParticipants(email)
            }
        }, 500)
    }
})

</script>
